import flatpickr from 'flatpickr';
import { INPUT_GROUP_CONTAINER_SELECTOR } from 'stdjs/form-element';

var parentElementSelector = INPUT_GROUP_CONTAINER_SELECTOR;
var clearButtonSelector = '.date-picker-clear';

export function getDefaultFlatpickrOptionsDate( userDateFormat, extraOptions = {} ){
    
    flatpickr.l10ns.default.firstDayOfWeek = 1;  
    
    var flatpickrOptions = {
        enableTime: false,
        dateFormat: "Y-m-d",
        altInput: true,
        altFormat: userDateFormat,
        disableMobile: true,
        allowInput: true,
        onClose(dates, currentdatestring, picker) {
            picker.setDate(picker.altInput.value, true, picker.config.altFormat)
        }
    };
    
    Object.assign(flatpickrOptions, extraOptions);
    
    return flatpickrOptions;
}

export function getDefaultFlatpickrOptionsDateTime( userDateFormat, userTimeFormat, extraOptions = {} ){
        
    flatpickr.l10ns.default.firstDayOfWeek = 1;
    
    var flatpickrOptions = {
        enableTime: true,
        dateFormat: "Y-m-d H:i:S",
        altInput: true,
        altFormat: userDateFormat + " " + userTimeFormat["displayFormat"],
        time_24hr: userTimeFormat["hr24"],
        enableSeconds: userTimeFormat["seconds"],
        disableMobile: true,
        allowInput: true,        
        onClose(dates, currentdatestring, picker){
        picker.setDate(picker.altInput.value, true, picker.config.altFormat)
        }
    };
    
    Object.assign(flatpickrOptions, extraOptions);

    return flatpickrOptions;
  
}

export function getDefaultFlatpickrOptionsTime( userTimeFormat, extraOptions = {} ){
        
    flatpickr.l10ns.default.firstDayOfWeek = 1;
    
    var flatpickrOptions = {
        noCalendar: true,
        enableTime: true,
        dateFormat: 'H:i:S',
        altInput: true,
        altFormat: userTimeFormat["displayFormat"],
        time_24hr: userTimeFormat["hr24"],
        disableMobile: true,
        allowInput: true,        
        onClose(dates, currentdatestring, picker){
        picker.setDate(picker.altInput.value, true, picker.config.altFormat)
        }
    };
    
    Object.assign(flatpickrOptions, extraOptions);

    return flatpickrOptions;
  
}

function initPickerCore( $input, flatpickrOptions ){
    $input = $( $input );
        
    flatpickrOptions.altInputClass = $input.attr("class") + " datePickerAltInput";    
    
    var flatpickr = $input.flatpickr( flatpickrOptions );      
    
    $input.closest( parentElementSelector ).on( "click", clearButtonSelector, function( e ){    
        flatpickr.clear();
    });
    
    return flatpickr;
}

export function initDatePicker( $input, userDateFormat, extraOptions = {} ){

    return initPickerCore( $input, getDefaultFlatpickrOptionsDate( userDateFormat, extraOptions ) );

}

export function initDateTimePicker( $input, userDateFormat, userTimeFormat, extraOptions = {} ){

    return initPickerCore( $input, getDefaultFlatpickrOptionsDateTime( userDateFormat, userTimeFormat, extraOptions ) );
    
}

export function initTimePicker( $input, userTimeFormat, extraOptions = {} ){

    return initPickerCore( $input, getDefaultFlatpickrOptionsTime( userDateFormat, extraOptions ) );

}

export function clearPicker( $input ){
    $input = $( $input );
    $input.get(0)._flatpickr.clear();
}